import { useRef } from 'react';

/**
 * Unlike useEffect with an empty array, useOnce callback fires immediately.
 */
function useOnce(callback?: () => unknown) {
    const mounted = useRef(false);

    if (!mounted.current) {
        mounted.current = true;

        if (callback) {
            callback();
        }

        return true;
    }

    return false;
}

export default useOnce;
